import { List } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useActiveSchoolId } from '../../hooks/useActiveSchoolId';
import type { StudentDto } from '../../pages/Exams/ExamDetail';
import { trpc } from '../../utils/trcp';
import EmptyData from '../EmptyData';
import { EmptyText, ListItem, ListItemContent } from './UserSearch';

const Title = styled.h3`
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	background-color: #fff;
`;

interface Props {
	handleStudentSelect: (student: StudentDto) => void;
}

export const LastUserSearch = ({ handleStudentSelect }: Props) => {
	const [focusedIndex, setFocusedIndex] = React.useState<number | null>(null);
	const { activeSchoolId } = useActiveSchoolId();
	const userLastSearch = trpc.userLastSearch.getUserLastSearch.useQuery({ schoolId: activeSchoolId });

	return (
		<List
			style={{ backgroundColor: 'white' }}
			locale={{
				emptyText: (
					<>
						<EmptyData />
						<EmptyText data-testId="user-search-list-empty-text">
							Zatím neexistuje historie vyhledávání
						</EmptyText>
					</>
				),
			}}
			loading={userLastSearch.isFetching}
			header={<Title>Nedávné výhledávání</Title>}
			bordered
			dataSource={userLastSearch.data}
			renderItem={(student, index) => (
				<ListItem
					$active={focusedIndex === index}
					onClick={() => handleStudentSelect(student)}
					onMouseEnter={() => setFocusedIndex(index)}
					data-testid={`user-search-list-item-${index}`}
				>
					<ListItemContent student={student} search="" />
				</ListItem>
			)}
		/>
	);
};
